import React from "react";
import { Accordion } from "react-bootstrap";
import "./WorkItemForm.css";
import moment from "moment";
import PropTypes from "prop-types";
import WorkItemFormCleanData from "./WorkItemFormCleanData";

function WorkItemForm({ form, mode }) {
  if (mode === "single") {
    return (
      <>
        <h2>{form.name}</h2>
        <WorkItemFormCleanData cleanData={form.cleanData} />
      </>
    );
  }

  return (
    <Accordion.Item eventKey={form.name}>
      <Accordion.Header>
        {form.name} (Created On{" "}
        {moment(form.createdOn).format("DD/MM/YYYY h:mm a")})
      </Accordion.Header>
      <Accordion.Body>
        <WorkItemFormCleanData cleanData={form.cleanData} />
      </Accordion.Body>
    </Accordion.Item>
  );
}

WorkItemForm.propTypes = {
  mode: PropTypes.oneOf(["single", "multi"]).isRequired,
  form: PropTypes.shape({
    name: PropTypes.string,
    createdOn: PropTypes.number,
    cleanData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        data: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default WorkItemForm;
